export default __webpack_public_path__ + "static/SuisseIntl-a9ba7462549f1056eb3330ac28eccc69.woff";